// services/productService.ts

import apiClient from "../../admin/api/apiClient";
import { Category } from "./interface/types";

const API_PATH = process.env.REACT_APP_API_PATH;

// export interface Product {
//   id: number;
//   title: string;
//   price: number;
//   image: string;
//   rating?: number;
// }

export interface ProductImage {
  imageURL: string;
  imageAngle?: string;
  isPrimary?: boolean;
  displayOrder?: number;
}

export interface Product {
  productID: number;
  productName: string;
  productSlug: string;
  sellingPrice: number;
  mrp: number;
  discountPercent: number;
  images: ProductImage[];
}

export const getProducts = async () => {
  const response = await apiClient.get(`/Public/GetProducts`);
  return response.data.dataList || [];
};



export const getCategories = async () => {
  const res = await apiClient.get(`/Public/GetCategories`);
  return res.data;
};

export const getHomeTrendingProducts = async () => {
  const res = await apiClient.get(`/Public/GetHomeTrendingProducts`);
  return res.data;
};

